export const isIOSDevice = () => {
  return (navigator.userAgent.match(/ip(hone|ad|od)/i) && !navigator.userAgent.match(/(iemobile)[/\s]?([\w.]*)/i))
}



// WEBPACK FOOTER //
// ./src/utils/device.js